(function($){
  'use strict';

  function words(text, limit){
    var clean=(text||'').replace(/\s+/g,' ').trim();
    if(!clean) return '';
    var parts=clean.split(' ');
    return parts.length>limit ? parts.slice(0,limit).join(' ')+'…' : clean;
  }

  function injectTrust(){
    if($('.misk-purchase-trust').length) return;
    var html='<div class="misk-purchase-trust" aria-label="Shipping and returns"><div><strong>Shipping within Jordan</strong> · Processing 1–3 business days · Delivery 2–5 business days</div><div><strong>7-day returns</strong> · <a href="/policies/shipping-policy">Shipping policy</a> · <a href="/policies/refund-policy">Return policy</a></div></div>';
    var $anchor=$('.pro-details-quality').first();
    if($anchor.length) $anchor.after(html);
  }

  function injectDescription(){
    if($('.misk-product-summary').length || $('.product-description:visible').length) return;
    var canonical=document.querySelector('link[rel="canonical"]');
    var path=canonical ? new URL(canonical.href).pathname : window.location.pathname;
    if(path.indexOf('/products/')===-1) return;
    fetch(path.replace(/\/$/,'')+'.js', {credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error('product json'); return r.json(); })
      .then(function(p){
        var tmp=document.createElement('div');
        tmp.innerHTML=p.description||'';
        var text=words(tmp.textContent||tmp.innerText||'',40);
        if(!text) return;
        var $summary=$('<div class="misk-product-summary"></div>').text(text);
        var $target=$('.product-details-price').first();
        if($target.length) $target.after($summary);
      })
      .catch(function(){});
  }

  function simplifyPurchase(){
    $('.dynamic_btn').hide();
    $('.custom-payment-options').hide();
  }

  function apply(){
    if(!$('form[action*="/cart/add"]').length && window.location.pathname.indexOf('/products/')===-1) return;
    simplifyPurchase();
    injectDescription();
    injectTrust();
  }

  $(apply);
  $(document).on('shopify:section:load',apply);
})(jQuery);
